import { extendTheme } from "@mui/joy/styles";

const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: "#e0f5fc",
          100: "#b1e7f7",
          200: "#7ed7f1",
          300: "#4ac7e8",
          400: "#21bce1",
          500: "#00b1d9",
          600: "#00a2c6",
          700: "#008eab",
          800: "#007a92",
          900: "#005866",
        },
      },
    },
  },
  components: {
    JoyModal: {
      styleOverrides: {
        backdrop: {
          backdropFilter: "blur(2px)",
        },
      },
    },
  },
});

export default theme;
